import { render, staticRenderFns } from "./PT420MemberDeleteParts.vue?vue&type=template&id=571299db&"
import script from "./PT420MemberDeleteParts.vue?vue&type=script&lang=js&"
export * from "./PT420MemberDeleteParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports